import { Injectable } from "@angular/core";
import {
  Router,
  CanActivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
} from "@angular/router";

import { AuthService } from "../service/auth.service";
import { TokenStorageService } from "../service/token-storage.service";

@Injectable({
  providedIn: "root",
})
export class AuthGuard implements CanActivate {
  constructor(
    private authService: AuthService,
    private router: Router,
    private tokenStorage: TokenStorageService
  ) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    const user = this.tokenStorage.getUser();
    const token = this.tokenStorage.getToken();
    
    if (!user || !token) {
      this.tokenStorage.signOut();
      this.router.navigate(["/authentication/signin"]);
      return false;
    }

    const userModules = this.tokenStorage.getUserModules();
    const expectedModules = route.data['modules'];

    if (expectedModules) {
      let hasAccess = false;

      if (Array.isArray(expectedModules)) {
        hasAccess = userModules.some(module => expectedModules.includes(module));
      } else {
        hasAccess = userModules.includes(expectedModules);
      }

      if (!hasAccess) {
        this.router.navigate(["/authentication/signin"]);
        return false;
      }
    }

    return true;
  }
}
